module.exports = __webpack_public_path__ + "static/media/united.6b505a88.png";